export default "__VITE_ASSET__SfOb5V0H__"